import _ from "underscore"
import config from "../../config"
import appErrorLogger from "../common/DataDogErrorLog"
import { deleteCookie, getCookie } from "../common/utils"
import axios from "axios"
import { Multipass } from "multipass-js"
import { mapTransactions } from "../MyAccount/Wallet/helpers"

const rewardsBaseUrl = config.host_rebag_api.slice(0, -4);

const authenticatedAxios = () => {
  const auth_token = getCookie('auth_token');
  return axios.create({
    timeout: 15000,
    headers: {'Authorization': auth_token}
  });
};

const axiosInstance = () => {
  return axios.create({
    timeout: 15000,
  });
};

export const createCheckoutWithLineItems = () => {
  const lineItemIds = JSON.parse(getCookie('subscription_only_checkout_line_item_ids'));
  const payload = {
    variant_ids: lineItemIds,
    apply_site_credit: !!getCookie('subscription_only_checkout_has_gift_cards'),
    discount: getCookie('subscription_only_checkout_has_discount') || ''
  }
  return  authenticatedAxios().post(`${rewardsBaseUrl}/shop-plus/api/checkout/`, payload)
    .catch(error => appErrorLogger('createCheckoutWithLineItems', error));
}

export const getBalanceProjection = _.memoize((amount, membershipPeriod) => {
  return axiosInstance().get(`${rewardsBaseUrl}/shop-plus/api/balance-projection/new/?amount=${amount}&payment_type=${membershipPeriod}`)
    .catch(error => appErrorLogger('getBalanceProjection', error));
}, (arg1, arg2) => `${arg1}-${arg2}`)

export const setCancelledGraphData = (membershipPeriod) => async (dispatch, getState) => {
  try {
    const selectedSubscription = getState().myAccountReducer.membershipData.selectedSubscription;
    const graphResponse = await getBalanceProjection(selectedSubscription.amount, membershipPeriod);
    dispatch({
      type: 'SET_MEMBERSHIP_GRAPH_DATA',
      payload: graphResponse.data.balance_projection
    });

  } catch (error) {
    appErrorLogger('setCancelledGraphData', error);
  }
}

export const setAdditionalContributionGraphData = () => async (dispatch, getState) => {
  const selectedContribution = getState().myAccountReducer.membershipData.selectedContribution;
  try {
    const graphResponse = await getBalanceProjection(selectedContribution.amount, 'yearly');
    dispatch({
      type: 'SET_MEMBERSHIP_GRAPH_DATA',
      payload: graphResponse.data.balance_projection
    });
  } catch (error) {
    appErrorLogger('setAdditionalContributionGraphData', error);
  }
}

export const getAuthenticatedBalanceProjection = () => (dispatch, getState) => {
  return new Promise(async (resolve) => {
    const selectedSubscription = getState().myAccountReducer.membershipData.selectedSubscription;
    const apiMembershipPeriod = getState().myAccountReducer.walletData.details.rewards_credit.membership_plan.rewards_billing_cycle;
    const initialSubscriptionPlan = getState().myAccountReducer.membershipData.initialSubscriptionPlan;
    let apiUrl = `${rewardsBaseUrl}/shop-plus/api/balance-projection/existing/?amount=${selectedSubscription.amount}`;

    if (apiMembershipPeriod) {
      apiUrl += `&payment_type=${apiMembershipPeriod}`;
    }

    try {
      const response = await authenticatedAxios().get(apiUrl);
      if (!initialSubscriptionPlan) {
        dispatch({
          type: 'SET_MEMBERSHIP_INITIAL_SUBSCRIPTION_PLAN',
          payload: {...selectedSubscription, projectedBonus: response.data.balance_projection[response.data.balance_projection.length - 1]}
        })
      }
      dispatch({
        type: 'SET_MEMBERSHIP_GRAPH_DATA',
        payload: response.data.balance_projection
      });
      resolve(response.data.balance_projection);
    } catch (error) {
      dispatch({
        type: 'SET_MEMBERSHIP_DATA_ERROR',
        payload: error.details || "The request is still processing, please try again later."
      });
      appErrorLogger('getBalanceProjection', error);
      resolve(null);
    }
  })
}

export const setSelectedContribution = (contribution) => dispatch => {
  dispatch({
    type: 'SET_SELECTED_CONTRIBUTION',
    payload: contribution
  })
}

export const setSelectedSubscription =  (subscription) => dispatch => {
  dispatch({
    type: 'SET_MEMBERSHIP_SELECTED_SUBSCRIPTION',
    payload: subscription
  })
}

export const getRewardsTransactionHistory = () => dispatch => {
  return new Promise(async(resolve) => {
    try {
      const response = await authenticatedAxios().get(`${rewardsBaseUrl}/shop-plus/api/rewards-activity/`);
      dispatch({
        type: 'SET_REWARDS_TRANSACTION_HISTORY',
        payload: mapTransactions(response.data),
      })
      resolve();
    } catch (error) {
      appErrorLogger('getRewardsTransactionHistory')
      resolve();
    }
  })
}

export const updateSubscription = (amount) => {
  return authenticatedAxios().post(`${rewardsBaseUrl}/api/v6/my-account/rewards_plus/update_monthly_contribution/`, {amount});
}

export const cancelSubscription = (reason) => {
  return authenticatedAxios().post(`${rewardsBaseUrl}/api/v6/my-account/rewards_plus/cancel_subscription/`, {reason: reason || ''});
}

export const goToOneOffPaymentCheckout = async (amount) => {
  const multipass = new Multipass(config.storefront_api.secret_key);
  const customerData = {
    email: getCookie('auth_email'),
    user: getCookie('auth_token'),
  };
  try {
    const checkoutResponse = await authenticatedAxios().post(`${rewardsBaseUrl}/shop-plus/api/checkout/oneoff/`, {amount});
    const redirect_after_url = checkoutResponse.data.checkout_web_url;
    const url = multipass.withCustomerData(customerData)
      .withDomain(config.storefront_api.domain)
      .withRedirect(redirect_after_url)
      .url();
    if (getCookie('is_checkout_finished')) {
      deleteCookie('is_checkout_finished');
    }
    window.location.href = url;
  } catch(error) {
    appErrorLogger('goToOneOffPaymentCheckout', error)
  }
}

export const submitRefundRequest = (contractId) => {
  return authenticatedAxios().put(`${rewardsBaseUrl}/api/v6/my-account/rewards_plus/refund/`, {contract_id: contractId})
}

export const finalizeRewardsCheckout = (orderId) => {
  return new Promise(async (resolve) => {
    try {
      await authenticatedAxios().post(`${rewardsBaseUrl}/api/v6/shop/finalize-rewards-checkout/`, {order_id: orderId});
      resolve();
    } catch (error) {
      appErrorLogger('finalizeRewardsCheckout', error);
      resolve();
    }
  })
}

export const checkRewardsPlusStatus = () => {
  return authenticatedAxios().get(`${rewardsBaseUrl}/api/v6/my-account/rewards_plus/is_member/`);
}
